import { productType } from "./productType";

const setProductType = (data) => ({ type: productType.SET_PRODUCT_TYPE, payload: data });

export { setProductType };